import React from "react";
import { useTranslation } from "react-i18next";
import { useFileDropHandlers } from "src/ui/utils/useFileDropHandlers";
import { makeStyles } from "tss-react/mui";

import ArrowFileUp from "@dashboard/files/components/ArrowFileUp";
import { alpha, Typography } from "@mui/material";
import { showErrorToast } from "@shared/toasts/Toasts";

const useStyles = makeStyles()((theme) => ({
    wrapper: {
        position: "relative",
    },
    overlay: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(1),
        border: `2px dashed ${theme.palette.emteria.action}`,
        borderRadius: 12,
        backgroundColor: alpha(theme.palette.emteria.background.paperDeep, 0.9),
        pointerEvents: "none",
    },
    label: {
        fontSize: 18,
        textAlign: "center",
        color: theme.palette.emteria.text.primary,
    },
}));

type Props = {
    children: React.ReactNode;
    onFiles: (files: File[]) => void;
    disabled?: boolean;
    disabledReason?: string;
    className?: string;
};

export const FileDropOverlay = (props: Props) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation(["pages"]);
    const fileDropHandlers = useFileDropHandlers<HTMLDivElement>({
        onFiles: props.onFiles,
        disabled: props.disabled,
        onDisabledDrop: () => showErrorToast(props.disabledReason),
    });

    return (
        <div className={cx(classes.wrapper, props.className)} data-testid="file-drop-overlay" {...fileDropHandlers}>
            {props.children}
            {fileDropHandlers.isDragging && !props.disabled ? (
                <div className={classes.overlay}>
                    <ArrowFileUp />
                    <Typography className={classes.label}>{t("pages:filesPage.dropOverlay.label")}</Typography>
                </div>
            ) : null}
        </div>
    );
};
